import { redirect, RedirectType } from 'next/navigation'

// Define the response type for the auth API
interface AuthResponse {
  authUrl: string
}

// Define error response type
interface AuthErrorResponse {
  error: string
  message?: string
}

export async function handleLogin() {
  try {
    const res = await fetch('/api/auth', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    // Check if the response is ok
    if (!res.ok) {
      const errorData: AuthErrorResponse = await res.json()
      throw new Error(errorData.message || errorData.error || `HTTP error! status: ${res.status}`)
    }

    const data: AuthResponse = await res.json()
    // Validate that we have an authUrl
    if (!data.authUrl || typeof data.authUrl !== 'string') {
      throw new Error('Invalid response: authUrl is missing or not a string')
    }

    redirect(data.authUrl, RedirectType.push)
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Login error:', error)
    // Re-throw the error so it can be handled by the calling component
    throw error
  }
}
